import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { AuthenticationService } from '../../../services/authentication.service';
import { Router } from '@angular/router';
import { HelpService } from '../../../services/help.service';

@Component({
    selector: 'lex-manage-password',
    templateUrl: './manage-password.component.html',
    styleUrls: ['./manage-password.component.scss'],
    standalone: false
})
export class ManagePasswordComponent implements OnInit {
	public managePasswordForm: UntypedFormGroup;
	public hidePassword = true;
	public hideNewPassword = true;
	public hideConfirmPassword = true;
	public errorMessage: string;
	public passwordRequirementMet: boolean = false;

	constructor(
		private authenticationService: AuthenticationService,
		private formBuilder: UntypedFormBuilder,
		private router: Router,
		private helpService: HelpService
	) {
	}

	ngOnInit(): void {
		this.managePasswordForm = this.formBuilder.group({
			password: [''],
			newPassword: [''],
			confirmPassword: ['']
		});

		this.helpService.updateHelpLink('management-menu/change-password');
	}

	onSubmit() {
		this.errorMessage = '';

		if (!this.passwordRequirementMet)
			return;

		this.authenticationService.changePassword(this.managePasswordForm.value.password, this.managePasswordForm.value.newPassword).subscribe({
			next: () => {
				//if success, return to /home/dashboard
				this.router.navigate(['/']);
			},
			error: (errorResponse) => {
				this.managePasswordForm.controls['password'].setErrors({ errorMessage: true });
				this.errorMessage = errorResponse?.error ?? 'An error has occurred- Invalid Password';
			}
		}
		);
	}

	onCancel() {
		this.router.navigate(['/']);
	}
}
